import { render, staticRenderFns } from "./WheelchairAccessories.vue?vue&type=template&id=143ff20e"
import script from "./WheelchairAccessories.vue?vue&type=script&lang=js"
export * from "./WheelchairAccessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports